<template>
  <li class="listitem">
    <div class="year">{{ listItem.year }}</div>
    <a 
      :aria-label="`${listItem.year}, ${listItem.title}, ${$texts.pubType} ${listItem.label}`" 
      class="title" 
      :href="listItem.link">
        <SistaOrdet :text="listItem.title"></SistaOrdet>
    </a>
    <div class="host">{{ listItem.host }}</div>
    <div class="authors">{{ listItem.authors }}</div>
  </li>
</template>

<script>
import Image from "../../image/image.vue";
import Icon from "../../image/icon.vue";
import SistaOrdet from "../../helpers/sistaordet.vue";

export default {
  name: "ListItem",
  props: {
    listItem: Object,
  },
  components: {
    Image,
    Icon,
    SistaOrdet,
  },
};
</script>
